import LOG from '../logging/Logger'

export default class SimpleCache {
  constructor() {
    this.cache = {}
  }

  isValid(str) {
    // Careful a valid key could be 'false'
    return str !== null && str !== undefined
  }

  lookupKey(key, fillCacheFunction) {
    return this.lookupSubKey(key, null, fillCacheFunction)
  }

  lookupSubKey(key, subKey, fillCacheFunction) {
    if (!this.isValid(key)) {
      LOG.error('Invalid Cache Key', key)
      return fillCacheFunction()
    }

    let item = null
    if (this.isValid(subKey)) {
      if (this.cache[key] && this.cache[key].subKeys) {
        item = this.cache[key].subKeys[subKey]
      } else {
        this.cache[key] = { subKeys: {} }
      }
      if (!this.isValid(item)) {
        LOG.debug('Query does not exist in cache', key)
        item = fillCacheFunction()
        LOG.debug('Adding query to cache', key, subKey, item)
        this.cache[key].subKeys[subKey] = item
      }
    } else {
      item = this.cache[key] ? this.cache[key].value : null
      if (!this.isValid(item)) {
        LOG.debug('Query does not exist in cache', key)
        item = fillCacheFunction()
        this.cache[key] = { value: item }
        LOG.debug('Adding query to cache', key, item)
      }
    }

    return item
  }

  clear(key = null, subKey = null) {
    if (this.isValid(key)) {
      if (this.isValid(subKey)) {
        LOG.debug('Clear cache item', key, subKey)
        if (this.cache[key]) {
          this.cache[key][subKey] = null
        }
      } else {
        LOG.debug('Clear cache item', key)
        this.cache[key] = null
      }
    } else {
      LOG.debug('Clear cache')
      this.cache = {}
    }
  }
}
